import { ProcessTypeEnum } from 'src/app/shared/interfaces/process.interface';

export interface Report {
	id: number;
	name: string;
	types?: ProcessTypeEnum[];
	display?: boolean;
}

export interface ReportDescription {
	title: string;
	name: string;
	contents?: Array<{ title?: string, description: string }>;
}

export enum ReportType {
	StatusReport = 1,
	GoalsReport = 2,
	TwoPlusTwoCoachingReport = 3,
	FreeEvaluationMidYearReport = 4,
	FreeEvaluationEndYearReport = 5,
	ThreeSixtyEvaluationReport = 6,
	ThreeSixtyEvaluationManagerReport = 7,
	ThreeSixtyEvaluatorsSelectionReport = 8,
	SelfManagerReport = 9,
	ExecutiveReport = 10,
	ExecutiveReportWithEvaluator = 11,
	DiversityCheck = 12,
	Feedback = 13,
	FinalFeedback = 14,
	SelfEvaluationMidYear = 15,
	GenericProcess = 16,
	ECSuccessFactorsReport = 17,
	SelfEvaluationWithoutAnswers = 18,
	HistoricExecutiveReportWithEvaluator = 19,
    AllUsersReport = 20,
    ReviewAndPromotion = 21,
    AllEvaluationReport = 22,
	HeadEvaluationReport = 23,
	ConsolidatedCalibrationReport = 24,
    CalibrationReport = 25
}
